import Cookies from 'universal-cookie';

export function formatName(firstName, familyName) {
  if (firstName && familyName) {
    return `${firstName} ${familyName}`;
  } else if (firstName) {
    return firstName;
  } else if (familyName) {
    return familyName;
  }
  return 'Guest Name Unknown';
}

export function resetGuestSearchesNotActedOn() {
  const cookies = new Cookies();
  cookies.remove('guestSearchesNotActedOn');
  cookies.remove('rsvpSearchDisabled');
}

export function scrollToTop(behavior = 'smooth') {
  window.scroll({
    top: 0,
    left: 0,
    behavior,
  });
}



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/RsvpForm/utils.js